import { render, staticRenderFns } from "./AffidavitOfPersonalService.vue?vue&type=template&id=515acd91"
import script from "./AffidavitOfPersonalService.vue?vue&type=script&lang=ts"
export * from "./AffidavitOfPersonalService.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports